export default __webpack_public_path__ + "def_Image.50f9385b.png";